import * as React from 'react';
import * as experts from './style.module.scss';
export const SmiExperts = ({ noLinks }) => {
  return (
    <section className={experts.experts}>
      <div className="container">
        <h2 className={experts.experts__title}>
          О нас говорят эксперты:
        </h2>
        {
          noLinks ?
            <ul className={experts.experts__list}>
              <p className={experts.experts__item}>
                Первый канал
              </p>
              <p className={experts.experts__item}>
                Аргументы и факты
              </p>
              <p className={experts.experts__item}>
                Телеканал 78
              </p>
            </ul>
            :
            <ul className={experts.experts__list}>
              <a href="/about/news/nikolay_yagodkin_i_advance_na_pervom_kanale/" className={experts.experts__item}>
                Первый канал
              </a>
              <a href="/about/news/aif_peterburg/" className={experts.experts__item}>
                Аргументы и факты
              </a>
              <a href="/about/news/advance_na_telekanale_78/" className={experts.experts__item}>
                Телеканал 78
              </a>
            </ul>
        }
      </div>
    </section>
  );
};
